import { render, staticRenderFns } from "./AsideNavItem.vue?vue&type=template&id=0b37792b&"
import script from "./AsideNavItem.vue?vue&type=script&lang=js&"
export * from "./AsideNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports